// extracted by mini-css-extract-plugin
module.exports = {"container":"_U","imgContainer":"aV","content":"bV","brand":"cV","product":"dV","price":"eV","noLink":"fV"};